<template>
  <div class="teacher-class-score">
    <div class="summary">
      <div class="row">
        <div>
          <div class="sum-label">综合评分</div>
          <div class="score"><span>{{ scoreMain }}</span><small> / 5.00</small></div>
        </div>
        <div class="sum-right">
          <div class="big"><span class="solid">{{ solidStars }}</span><span>{{ hollowStars }}</span></div>
          <div class="grade">{{ gradeText }}</div>
        </div>
      </div>
    </div>
    <div class="rated-row">
      <div class="rated" @click="onRatedClick">已评分 <strong class="rated-num">{{ ratedCountText }}</strong> 节</div>
      <span class="rated-hint">点击数字筛选明细</span>
    </div>
    <div class="score-filter">
      <span class="label">上课日期</span>
      <DatePicker
        type="date"
        format="yyyy-MM-dd"
        :value="startDate"
        :clearable="false"
        transfer
        placeholder="开始日期"
        style="width: 140px"
        @on-change="onStartDateChange">
      </DatePicker>
      <span class="to">至</span>
      <DatePicker
        type="date"
        format="yyyy-MM-dd"
        :value="endDate"
        :clearable="false"
        transfer
        placeholder="结束日期"
        style="width: 140px"
        @on-change="onEndDateChange">
      </DatePicker>
      <span class="filter-item">
        <span class="label extra">学导</span>
        <Input
          v-model="queryParam.studyAdviserNickname"
          placeholder="支持模糊搜索"
          style="width: 140px">
        </Input>
      </span>
      <span class="filter-item">
        <span class="label extra">课程顾问</span>
        <Input
          v-model="queryParam.adviserNickname"
          placeholder="支持模糊搜索"
          style="width: 140px">
        </Input>
      </span>
      <span class="filter-item">
        <span class="label extra">课程类型</span>
        <Select
          v-model.number="queryParam.lsnType"
          placeholder="全部"
          clearable
          style="width: 140px">
          <Option v-for="item in $constant.bookLessonOpenedLsnType" :value="item.code" :key="item.code">{{ item.text }}</Option>
        </Select>
      </span>
      <span class="filter-item">
        <span class="label extra">课程状态</span>
        <Select
          v-model.number="queryParam.lsnSelStatus"
          placeholder="全部"
          clearable
          style="width: 140px">
          <Option v-for="item in $constant.lsnSelStatus" :value="item.code" :key="item.code">{{ item.text }}</Option>
        </Select>
      </span>
      <span class="filter-item">
        <span class="label extra">是否评分</span>
        <Select v-model.number="queryParam.classFeedbackRated" placeholder="全部" clearable style="width: 140px">
          <Option :value="1">已评分</Option>
          <Option :value="0">未评分</Option>
        </Select>
      </span>
      <Button type="primary" style="margin-left: 12px" @click="search">查询</Button>
    </div>
    <List
      ref="dataList"
      :tableColumns="columns"
      listUrl="/bookLesson/opened/list"
      :params="queryParam"
      :reload="reload"
      :sync-route="false">
    </List>
    <BookTchFeedbackModal :openedId="openedId" :readonly="true" v-model="showBookTchFeedbackModal" @on-close="showBookTchFeedbackModal=false"></BookTchFeedbackModal>
    <BookTchScoreFeedbackModal :openedId="openedId" :readonly="true" v-model="showBookTchScoreFeedbackModal" @on-close="showBookTchScoreFeedbackModal=false"></BookTchScoreFeedbackModal>
    <BookUserFeedbackModal :openedId="openedId" v-model="showBookUserFeedbackModal" @on-close="showBookUserFeedbackModal=false"></BookUserFeedbackModal>
    <StudentWriteReviewDemoModal :openedId="openedId" :readonly="true" :value="studentWriteReviewDemoModal" @on-close="studentWriteReviewDemoModal=false"></StudentWriteReviewDemoModal>
    <StudentWriteReviewRegularModal :openedId="openedId" :readonly="true" :value="studentWriteReviewRegularModal" @on-close="studentWriteReviewRegularModal=false"></StudentWriteReviewRegularModal>
    <StudentWriteReviewFinishLevelModal :openedId="openedId" :readonly="true" :value="studentWriteReviewFinishLevelModal" @on-close="studentWriteReviewFinishLevelModal=false"></StudentWriteReviewFinishLevelModal>
    <StudentWriteReviewDemoV2Modal :openedId="openedId" :readonly="true" :value="studentWriteReviewDemoV2Modal" @on-close="studentWriteReviewDemoV2Modal=false"></StudentWriteReviewDemoV2Modal>
    <StudentWriteReviewRegularV2Modal :openedId="openedId" :readonly="true" :value="studentWriteReviewRegularV2Modal" @on-close="studentWriteReviewRegularV2Modal=false"></StudentWriteReviewRegularV2Modal>
    <StudentWriteReviewFinishLevelV2Modal :openedId="openedId" :readonly="true" :value="studentWriteReviewFinishLevelV2Modal" @on-close="studentWriteReviewFinishLevelV2Modal=false"></StudentWriteReviewFinishLevelV2Modal>
    <Modal v-model="showClassFeedback" title="课堂反馈" width="960" :footer-hide="true" :mask-closable="false">
      <class-feedback
        v-if="showClassFeedback"
        :lesson-opened-id="classFeedbackOpenedId"
        :embedded="true"
        @saved="onClassFeedbackSaved"
      ></class-feedback>
    </Modal>
  </div>
</template>
<script>
import BookUserFeedbackModal from '../lesson/BookUserFeedbackModal.vue'
import BookTchFeedbackModal from '../lesson/BookTchFeedbackModal.vue'
import BookTchScoreFeedbackModal from '../lesson/BookTchScoreFeedbackModal.vue'
import StudentWriteReviewDemoModal from '../user/StudentWriteReviewDemoModal.vue'
import StudentWriteReviewDemoV2Modal from '../user/StudentWriteReviewDemoV2Modal.vue'
import StudentWriteReviewRegularModal from '../user/StudentWriteReviewRegularModal.vue'
import StudentWriteReviewRegularV2Modal from '../user/StudentWriteReviewRegularV2Modal.vue'
import StudentWriteReviewFinishLevelModal from '../user/StudentWriteReviewFinishLevelModal.vue'
import StudentWriteReviewFinishLevelV2Modal from '../user/StudentWriteReviewFinishLevelV2Modal.vue'
import ClassFeedback from '../lesson/ClassFeedback.vue'

const GRADES = {
  1: '不合格',
  2: '待改进',
  3: '合格',
  4: '良好',
  5: '优秀'
}

export default {
  name: 'TeacherClassScore',
  components: {
    BookUserFeedbackModal,
    BookTchFeedbackModal,
    BookTchScoreFeedbackModal,
    StudentWriteReviewDemoModal,
    StudentWriteReviewDemoV2Modal,
    StudentWriteReviewRegularModal,
    StudentWriteReviewRegularV2Modal,
    StudentWriteReviewFinishLevelModal,
    StudentWriteReviewFinishLevelV2Modal,
    ClassFeedback
  },
  props: {
    tchId: {
      type: Number,
      default: null
    }
  },
  data () {
    let $constant = this.$constant
    let $moment = this.$moment
    let start = $moment().startOf('day').subtract(6, 'days')
    let end = $moment().endOf('day')
    return {
      startDate: start.format('YYYY-MM-DD'),
      endDate: end.format('YYYY-MM-DD'),
      queryParam: {
        tchId: this.tchId,
        startTime: start.format('X'),
        endTime: end.format('X'),
        studyAdviserNickname: '',
        adviserNickname: '',
        lsnType: null,
        lsnSelStatus: null,
        classFeedbackRated: null
      },
      reload: 0,
      ratedCount: 0,
      totalStar: 0,
      openedId: null,
      showBookUserFeedbackModal: false,
      showBookTchFeedbackModal: false,
      showBookTchScoreFeedbackModal: false,
      studentWriteReviewDemoModal: false,
      studentWriteReviewDemoV2Modal: false,
      studentWriteReviewRegularModal: false,
      studentWriteReviewRegularV2Modal: false,
      studentWriteReviewFinishLevelModal: false,
      studentWriteReviewFinishLevelV2Modal: false,
      showClassFeedback: false,
      classFeedbackOpenedId: '',
      classFeedbackRow: null,
      columns: [
        {
          title: '课程信息',
          width: 180,
          render: (h, params) => {
            let row = params.row
            let typeEnum = $constant.getEnum($constant.bookLessonOpenedLsnType, row.lsnType)
            let courseTypeEnum = $constant.getEnum($constant.courseType, row.courseType)
            let cType = courseTypeEnum && courseTypeEnum.text
            if (cType) {
              cType = '课程类别:' + cType
            } else {
              cType = ''
            }
            return h('div', [
              h('p', row.id),
              h('p', row.lessonTitle),
              h('p', {style: {'font-size': '12px', color: 'red'}}, cType),
              h('p', {style: {'font-size': '12px', color: '#2d8cf0'}}, '课程类型:' + (typeEnum && typeEnum.text))
            ])
          }
        },
        {
          title: '上课时间',
          width: 180,
          render: (h, params) => {
            let lsnBeginTime = params.row.lsnBeginTime
            let week = $moment(lsnBeginTime, 'X').day()
            return h('span', $moment(lsnBeginTime, 'X').format('YYYY-MM-DD HH:mm') + ' ' + $constant.weekZh[week])
          }
        },
        {
          title: '时长',
          align: 'center',
          width: 80,
          render: (h, params) => {
            let row = params.row
            let minutes = row.courseTime
            if (minutes === null || minutes === undefined || minutes === '') {
              minutes = (row.lsnEndTime - row.lsnBeginTime) / 60
            }
            return h('span', minutes)
          }
        },
        {
          title: '学生',
          width: 160,
          render: (h, params) => {
            let row = params.row
            return h('span', row.uid + '-' + row.userNickname)
          }
        },
        {
          title: '状态',
          width: 120,
          render: (h, params) => {
            let statusEnum = $constant.getEnum($constant.lsnSelStatus, params.row.lsnSelStatus)
            return h('span', statusEnum && statusEnum.text)
          }
        },
        {
          title: '课堂反馈',
          align: 'center',
          width: 140,
          render: (h, params) => {
            let row = params.row
            let n = parseInt(row.classFeedbackStar, 10)
            if (!n || n < 1) {
              return h('span', '未评分')
            }
            if (n > 5) {
              n = 5
            }
            return h('span', {
              style: {color: '#f0a020', cursor: 'pointer', fontSize: '16px', letterSpacing: '1px'},
              on: {
                click: () => {
                  this.openClassFeedback(row)
                }
              }
            }, '★'.repeat(n))
          }
        },
        {
          title: '评价',
          width: 160,
          align: 'center',
          render: (h, params) => {
            let row = params.row
            let bookTchFeedbackUid = row.bookTchFeedbackUid
            let spanArr = []
            let version = row.version
            if (bookTchFeedbackUid) {
              let obj = h('a', {
                on: {
                  click: () => {
                    this.openedId = row.id
                    if (version === 0) {
                      if (row.lsnType === 1) {
                        this.showBookTchScoreFeedbackModal = true
                      } else {
                        this.showBookTchFeedbackModal = true
                      }
                    } else if (version === 1) {
                      if (row.lsnType === 1) {
                        this.studentWriteReviewDemoModal = true
                      } else if (row.lsnType === 2) {
                        if (row.stageSummary) {
                          this.studentWriteReviewFinishLevelModal = true
                        } else {
                          this.studentWriteReviewRegularModal = true
                        }
                      }
                    } else if (version === 2) {
                      if (row.lsnType === 1) {
                        this.studentWriteReviewDemoV2Modal = true
                      } else if (row.lsnType === 2) {
                        if (row.stageSummary) {
                          this.studentWriteReviewFinishLevelV2Modal = true
                        } else {
                          this.studentWriteReviewRegularV2Modal = true
                        }
                      }
                    }
                  }
                }
              }, '老师对学生评价')
              let her = 'https://test-h5.kouyujie.cn/std-report/report.html?bookLessonId=' + row.id
              if (this.$appConfig.active === 'prod') {
                her = 'https://h5.speakstreet.cn/std-report/report.html?bookLessonId=' + row.id
              }
              let previewLink = h('a', {
                attrs: {
                  href: her,
                  target: '_blank'
                },
                style: {
                  marginLeft: '10px'
                }
              }, '预览')
              spanArr.push(obj)
              spanArr.push(h('br'))
              if (row.lsnType === 1 && version === 2) {
                spanArr.push(h('br'))
                spanArr.push(previewLink)
                spanArr.push(h('br'))
              }
            }
            let bookUserFeedbackId = row.bookUserFeedbackId
            let bookUserFeedbackStar = row.bookUserFeedbackStar
            if (bookUserFeedbackId) {
              let obj2 = h('div', [
                h('Rate', {
                  props: {
                    disabled: true,
                    count: bookUserFeedbackStar,
                    value: bookUserFeedbackStar
                  },
                  style: {'font-size': '12px'}
                }),
                h('br'),
                h('a', {
                  on: {
                    click: () => {
                      this.openedId = row.id
                      this.showBookUserFeedbackModal = true
                    }
                  }
                }, '学生对老师评价')
              ])
              spanArr.push(obj2)
            }
            if (spanArr.length === 0) {
              return h('div', {style: {color: 'red'}}, '未评论')
            }
            return h('div', {style: {'font-size': '13px', color: 'red'}}, spanArr)
          }
        },
        {
          title: '监课/回放',
          width: 100,
          align: 'center',
          render: (h, params) => {
            if (params.row.liveUrl) {
              return h('a', {
                on: {
                  click: () => {
                    window.open(params.row.liveUrl)
                  }
                }
              }, '进入')
            }
            return h('span')
          }
        }
      ]
    }
  },
  computed: {
    hasScore () {
      let count = parseInt(this.ratedCount, 10)
      return !!count && count > 0
    },
    avg () {
      if (!this.hasScore) {
        return 0
      }
      return Number(this.totalStar) / parseInt(this.ratedCount, 10)
    },
    starCount () {
      if (!this.hasScore) {
        return 0
      }
      let n = Math.round(this.avg)
      if (n < 1) {
        n = 1
      }
      if (n > 5) {
        n = 5
      }
      return n
    },
    scoreMain () {
      if (!this.hasScore) {
        return '—'
      }
      return this.avg.toFixed(2)
    },
    solidStars () {
      if (!this.hasScore) {
        return ''
      }
      return '★'.repeat(this.starCount)
    },
    hollowStars () {
      if (!this.hasScore) {
        return '☆☆☆☆☆'
      }
      return '☆'.repeat(5 - this.starCount)
    },
    gradeText () {
      if (!this.hasScore) {
        return '待评分'
      }
      return GRADES[this.starCount] || '待评分'
    },
    ratedCountText () {
      let count = parseInt(this.ratedCount, 10)
      if (!count || count < 0) {
        return 0
      }
      return count
    }
  },
  created () {
    this.loadSummary()
  },
  watch: {
    tchId (val) {
      this.queryParam.tchId = val
      this.loadSummary()
      this.reload = new Date().getTime()
    }
  },
  methods: {
    onStartDateChange (value) {
      this.startDate = value
    },
    onEndDateChange (value) {
      this.endDate = value
    },
    search () {
      if (!this.startDate || !this.endDate) {
        return
      }
      let start = this.$moment(this.startDate, 'YYYY-MM-DD').startOf('day')
      let end = this.$moment(this.endDate, 'YYYY-MM-DD').endOf('day')
      this.queryParam.tchId = this.tchId
      this.queryParam.startTime = start.format('X')
      this.queryParam.endTime = end.format('X')
      this.queryParam.studyAdviserNickname = this.queryParam.studyAdviserNickname || ''
      this.queryParam.adviserNickname = this.queryParam.adviserNickname || ''
      let lsnType = this.queryParam.lsnType
      if (lsnType === '' || lsnType === null || lsnType === undefined) {
        this.queryParam.lsnType = null
      } else {
        lsnType = Number(lsnType)
        this.queryParam.lsnType = Number.isInteger(lsnType) && lsnType >= 0 ? lsnType : null
      }
      let lsnSelStatus = this.queryParam.lsnSelStatus
      if (lsnSelStatus === '' || lsnSelStatus === null || lsnSelStatus === undefined) {
        this.queryParam.lsnSelStatus = null
      } else {
        lsnSelStatus = Number(lsnSelStatus)
        this.queryParam.lsnSelStatus = Number.isInteger(lsnSelStatus) && lsnSelStatus > 0 ? lsnSelStatus : null
      }
      let classFeedbackRated = this.queryParam.classFeedbackRated
      if (classFeedbackRated === '' || classFeedbackRated === null || classFeedbackRated === undefined) {
        this.queryParam.classFeedbackRated = null
      } else {
        classFeedbackRated = Number(classFeedbackRated)
        this.queryParam.classFeedbackRated = Number.isInteger(classFeedbackRated) && (classFeedbackRated === 0 || classFeedbackRated === 1) ? classFeedbackRated : null
      }
      this.reload = new Date().getTime()
    },
    onRatedClick () {
      this.queryParam.classFeedbackRated = 1
      this.search()
    },
    loadSummary () {
      let self = this
      if (!this.tchId) {
        return
      }
      this.$http.get('/bookLesson/classFeedback/summary', {
        params: {
          tchId: this.tchId
        }
      }).then(function (res) {
        if (res && res.status === 'ok' && res.data) {
          self.ratedCount = res.data.ratedCount || 0
          self.totalStar = res.data.totalStar || 0
        } else {
          self.ratedCount = 0
          self.totalStar = 0
        }
      }).catch(function () {
        self.ratedCount = 0
        self.totalStar = 0
      })
    },
    openClassFeedback (row) {
      this.classFeedbackRow = row
      this.classFeedbackOpenedId = row.id
      this.showClassFeedback = true
    },
    onClassFeedbackSaved (payload) {
      let star = payload && payload.star
      let openedId = payload && payload.openedId
      let list = this.$refs.dataList
      let rows = list && list.tableData
      if (rows && rows.length) {
        for (let i = 0; i < rows.length; i++) {
          if (String(rows[i].id) === String(openedId)) {
            rows[i].classFeedbackStar = star
            break
          }
        }
        list.tableData = rows.slice()
      } else if (this.classFeedbackRow) {
        this.classFeedbackRow.classFeedbackStar = star
      }
      this.showClassFeedback = false
      this.classFeedbackRow = null
      this.loadSummary()
    }
  }
}
</script>
<style scoped>
.score-filter {
  margin-bottom: 12px;
}
.score-filter .label {
  margin-right: 8px;
}
.score-filter .filter-item {
  display: inline-block;
  white-space: nowrap;
  margin-left: 12px;
}
.score-filter .to {
  margin: 0 8px;
}
.summary {
  background: linear-gradient(135deg, #123a6b, #1a4d8f);
  color: #fff;
  border-radius: 16px;
  padding: 20px;
}
.summary .row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 8px;
}
.summary .score {
  font-size: 38px;
  font-weight: 700;
}
.summary .score small {
  font-size: 14px;
  font-weight: 400;
  opacity: .8;
}
.summary .big {
  font-size: 24px;
  letter-spacing: 2px;
}
.summary .big .solid {
  color: #f0a020;
}
.summary .grade {
  background: rgba(255, 255, 255, .16);
  padding: 4px 14px;
  border-radius: 20px;
  font-size: 13px;
  font-weight: 600;
}
.sum-label {
  font-size: 12px;
  opacity: .8;
}
.sum-right {
  text-align: right;
}
.rated-row {
  display: flex;
  align-items: baseline;
  flex-wrap: wrap;
  gap: 8px;
  margin: 8px 0 12px;
}
.rated {
  cursor: pointer;
}
.rated-num {
  font-weight: 700;
  color: #ed4014;
}
.rated-hint {
  font-size: 12px;
  color: #808695;
}
</style>



// WEBPACK FOOTER //
// TeacherClassScore.vue?5652c94f